import { Route } from 'react-router-dom'
import { AssignmentDetailPage } from '../pages/AssignmentDetailPage'
import { OrderDetailPage } from '../pages/OrderDetailPage'
import { OrderPhotosPage } from '../pages/OrderPhotosPage'

/**
 * Assignment/order detail routes, shared by the logged-in tab shell and the
 * short-link mini-app: a route added here reaches both outlets.
 */
export const assignmentDetailRoutes = () => [
  <Route
    key='assignment'
    exact
    path='/assignments/:assignmentId'
    component={AssignmentDetailPage}
  />,
  <Route
    key='assignment-order'
    exact
    path='/assignments/:assignmentId/orders/:orderId'
    component={OrderDetailPage}
  />,
  // Standalone order URL (v1 parity: waypoint/legacy links)
  <Route
    key='order'
    exact
    path='/orders/:orderId'
    component={OrderDetailPage}
  />,
]

/**
 * Photo screens, tab shell only: upload rides the main session's
 * PhotoUploadProvider, so the short-link mini-app leaves these out.
 * Not flag-gated: the page redirects back to the order when the flag is off
 * (a gated route would leave a blank outlet).
 */
export const orderPhotosRoutes = () => [
  <Route
    key='assignment-order-photos'
    exact
    path='/assignments/:assignmentId/orders/:orderId/photos'
    component={OrderPhotosPage}
  />,
  <Route
    key='order-photos'
    exact
    path='/orders/:orderId/photos'
    component={OrderPhotosPage}
  />,
]
